module.exports = __webpack_public_path__ + "static/img/hangyefenxi2.6135c1e2.png";